module.exports = __webpack_public_path__ + "media/images/aicomposz-logo-HighRes-White-Trans-6c83fbf5.png";